import React from "react";
import {
  IconGavel,
  IconContract,
  IconCertificate,
  IconBuildingSkyscraper,
  IconScale,
  IconHomeDollar,
  IconBulldozer,
  IconPaint,
  IconUsers
} from "@tabler/icons-react";
// Use this variable to change all the coll to actios on the sevice section
const c2aLink = "#";

const ServicesHome = () => {
  return (
    <section id="services" className="services">
      <div className="services--header">
        <h4>Servicios</h4>
      </div>
      <div className="services--body">
        {/* Service 1 */}
        <div className="service service__vender">
          <h3 className="service__title">Asesoría Legal Integral en Transacciones Inmobiliarias</h3>
          <IconGavel stroke={2} className="service__icon"/>
          <p className="service__description">
            Ofrecemos asesoramiento legal completo para compraventas, arrendamientos, y cualquier otro tipo de transacción inmobiliaria, asegurando el cumplimiento de regulaciones locales y la protección de los intereses de nuestros clientes. Realizamos estudios exhaustivos de la situación legal de inmuebles y terrenos, identificando posibles riesgos legales y fiscales.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 2 */}
        <div className="service service__asesorar">
          <h3 className="service__title">Gestión de Contratos</h3>
          <IconContract stroke={2} className="service__icon" />
          <p className="service__description">
            Gestión de Contratos	Redacción, revisión y negociación de contratos de arrendamiento, compraventa, promesa de compraventa, entre otros, garantizando que los términos y condiciones sean claros, equitativos y favorables para nuestros clientes.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 3 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Trámites Administrativos y Registrales</h3>
          <IconCertificate stroke={2} className="service__icon" />
          <p className="service__description">
            Brindamos asistencia en la obtención de permisos, licencias y certificados necesarios para el desarrollo de proyectos inmobiliarios, así como en la inscripción de propiedades en registros públicos y catastrales.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 4 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Resolución de Conflictos</h3>
          <IconScale stroke={2} className="service__icon" />
          <p className="service__description">
            Representación legal en casos de disputas relacionadas con contratos inmobiliarios, incumplimientos, vicios ocultos, desalojos, entre otros, buscando soluciones eficientes y favorables para nuestros clientes a través de la mediación, conciliación o litigio.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 5 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Planeación Urbanística, Zonificación y Avalúos</h3>
          <IconBuildingSkyscraper stroke={2} className="service__icon" />
          <p className="service__description">
            Asesoramos a nuestros clientes en la identificación y evaluación de oportunidades de desarrollo urbano, así como en la interpretación y aplicación de normativas municipales y urbanísticas para maximizar el potencial de sus propiedades. Realizamos avalúos profesionales de propiedades para determinar su valor real en el mercado. Este servicio es esencial para la planeación urbanística y la zonificación, proporcionando una base sólida para la toma de decisiones estratégicas en desarrollos y proyectos inmobiliarios. Nuestros avalúos son detallados y precisos, asegurando que nuestros clientes tengan una comprensión clara del valor de sus propiedades y terrenos.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 6 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Consultoría en Inversiones Inmobiliarias</h3>
          <IconHomeDollar stroke={2} className="service__icon" />
          <p className="service__description">
            Brindamos análisis de mercado, evaluación de riesgos y oportunidades, y recomendaciones estratégicas para inversionistas interesados en el sector inmobiliario, con el objetivo de optimizar el retorno de su inversión.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 7 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Asesoramiento en Proyectos de Construcción</h3>
          <IconBulldozer stroke={2} className="service__icon" />
          <p className="service__description">
            Ofrecemos asistencia legal en la planificación, ejecución y gestión de proyectos de construcción, incluyendo la revisión de contratos con contratistas, subcontratistas y proveedores, y la resolución de conflictos durante la obra.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 8 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Remodelaciones</h3>
          <IconPaint stroke={2} className="service__icon" />
          <p className="service__description">
            Proporcionamos servicios completos de remodelación y renovación de inmuebles, asegurando que las mejoras sean realizadas de acuerdo a los estándares de calidad y las regulaciones vigentes, optimizando así el valor de las propiedades.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
        {/* Service 9 */}
        <div className="service service__arrendar">
          <h3 className="service__title">Agente de Confianza y Administración Delegada</h3>
          <IconUsers stroke={2} className="service__icon" />
          <p className="service__description">
            Somos el agente de confianza para clientes del exterior que han adquirido inmuebles en Colombia, ofreciendo servicios de administración delegada que incluyen la gestión de pagos legales de impuestos, administración de inmuebles, supervisión de remodelaciones y mantenimiento, asegurando que los clientes mantengan el control sobre su inversión.
          </p>
          <a className="service__c2a" href={c2aLink}>Contactar con un Asesor</a>
          <hr />
        </div>
      </div>
    </section>
  );
};

export default ServicesHome;
